var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Vue from 'vue';
import { Component } from 'vue-property-decorator';
import * as API from './api';
import { UserCategory } from './user-service';
import RankView from './components/RankView';
let Rank = class Rank extends Vue {
    constructor() {
        super(...arguments);
        this.items = [];
    }
    getRank(proset) {
        return __awaiter(this, void 0, void 0, function* () {
            let [proitems, rankers, sumscores] = yield Promise.all([yield API.listProItem(proset.uid), yield API.getRank(proset.uid), yield API.listProSumScore(proset.uid)]);
            if (proitems !== 'Error' && rankers !== 'Error' && sumscores !== 'Error') {
                let d = {};
                for (let sumscore of sumscores) {
                    d[sumscore.uid] = sumscore.sumscore;
                }
                for (let proitem of proitems) {
                    proitem.sumscore = d[proitem.problem.uid];
                }
                return {
                    name: proset.name,
                    proitems: proitems,
                    rankers: rankers,
                };
            }
            return null;
        });
    }
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            let prosets = yield API.listProSet();
            if (prosets !== 'Error') {
                let works = [];
                for (let proset of prosets) {
                    if (!proset.hidden && proset.metadata.category !== UserCategory.universe) {
                        works.push(yield this.getRank(proset));
                    }
                }
                for (let item of yield Promise.all(works)) {
                    if (item !== null) {
                        this.items.push(item);
                    }
                }
            }
        });
    }
};
Rank = __decorate([
    Component({
        components: { RankView }
    })
], Rank);
export default Rank;



// WEBPACK FOOTER //
// ./src/Rank.vue